module.exports = __webpack_public_path__ + "static/fipcbrightsafari-709bb8d465af302f1e8754c98af9025e.jpeg";